<section class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
  <!-- Left: text content, starts at 120px top -->
  <div class="py-[60px] md:py-[120px] flex flex-col justify-center gap-8 relative z-10"
       data-aos="fade-up">
    <span
      class="inline-flex items-center py-2 ps-3.5 gap-2 bg-[rgba(76,234,99,0.08)] rounded-full text-sm font-medium w-fit">
      <app-icon name="tabler:shield" size="16" class="text-[#4CEA63]"/>
      <span class="pe-5 text-white text-sm">
        {{ 'recruiterProgram.hero.badge' | translate }}
      </span>
    </span>

    <h1 class="text-white text-[32px] md:text-[44px] lg:text-[58px] leading-[1.07] lg:leading-[62px] font-[900] tracking-[-2px]">
      {{ 'recruiterProgram.hero.titleStart' | translate }}
      <span class="text-[#2AED73]">
        {{ 'recruiterProgram.hero.titleMid' | translate }}
      </span>
      {{ 'recruiterProgram.hero.titleEnd' | translate }}
    </h1>

    <p class="text-white text-[17px] leading-[30px]">
      {{ 'recruiterProgram.hero.subtitle' | translate }}
    </p>

    <span class="text-[#CCD3DF] font-base leading-6">
      <span class="rtl:flip">
        <app-icon class="text-[#2AED73]" name="tabler:corner-down-left" size="16"/>
      </span>
      {{ 'recruiterProgram.hero.joinEliteHrDesc' | translate }}
    </span>

    <a [href]="getSignupUrl()" class="rounded-full py-4 px-8 bg-primary text-white w-fit">
      {{ 'recruiterProgram.hero.cta' | translate }}
    </a>
  </div>

  <!-- Right: full-height image, bleeds to right edge -->
  <div class="hidden lg:flex items-center" data-aos="fade-up" data-aos-delay="150">
    <app-responsive-img
      basePath="assets/images/recruiter-program"
      [langAware]="false"
      name="hero"
      [alt]="'recruiterProgram.hero.imageAlt' | translate"
      loading="eager"
      pictureClass="hero__img"
      imgClass="min-w-[108%] h-auto"
      sizes="50vw"
    />
  </div>
</section>
